<div class="container-sale" id="container-sale">
  <div class="card mb-3">
    <h3>Registro de PPE</h3>
  </div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <h3>Datos del documento</h3>
        <div class="form-group">
          <label for="client-input" class="form-label">Proveedor</label>
          <div class="input-group input-group-sm" style="margin-bottom: 1em;">
            <app-input-autocomplete [ruleToDisabled]="clients.length == 0 || autoGenerated || isTranslate" [allBorderRadius]="true"
              [inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un proveedor'"
              [filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
              (changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
              <ng-template #itemsTemplate let-filter>
                <!-- This is the content that will be projected -->
                <div items>
                  <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                    {{filter.name}}</h5>
                  <span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
                </div>
              </ng-template>
            </app-input-autocomplete>
          </div>
        </div>
        <div *ngIf="clientSelected">
          <div class="row">
            <h5 >Datos del proveedor</h5>
            <div class="row align-items-center">
              <div class="col-md-auto">
                <strong>Nombre:</strong> {{ clientSelected.name }}
              </div>
              <div class="col-md-auto">
                <strong>NIT:</strong> {{ clientSelected.nit }}
              </div>
              <div class="col-md-auto">
                <strong>Código:</strong> {{ clientSelected.code }}
              </div>
            </div>
          </div>

          <!-- Datos del documento -->
          <div class="row mb-3">
            <div class="col-md-3">
              <label>Fecha Documento</label>
              <input class="form-control" type="date" [(ngModel)]="document.date" [disabled]="autoGenerated || isTranslate"/>
            </div>
            <div class="col-md-3">
              <label>Mes de Ingreso</label>
              <input class="form-control" type="month" [(ngModel)]="document.month" [disabled]="autoGenerated || isTranslate"/>
            </div>
            <div class="col-md-5">
              <label>Tipo de documento:</label>
              <select class="form-control" [(ngModel)]="document.typeId" [disabled]="autoGenerated || isTranslate">
                <option *ngFor="let type of documentTypes" [value]="type.id">{{ type.name }}</option>
              </select>
            </div>
          </div>
    
          <div class="row mb-3">
            <div class="col-md-3">
              <label>Serie del Documento</label>
              <input class="form-control" [(ngModel)]="document.series" placeholder="Serie del documento" [disabled]="autoGenerated || isTranslate"/>
            </div>
            <div class="col-md-3">
              <label>No. de Documento</label>
              <input class="form-control" [(ngModel)]="document.number" placeholder="Número de documento" [disabled]="autoGenerated || isTranslate"/>
            </div>
            <div class="col-md-3">
              <label>Total Documento</label>
              <input class="form-control" type="number" [(ngModel)]="document.total" [disabled]="autoGenerated || isTranslate"/>
            </div>
            <div class="col-md-3">
              <label>Total Declarado</label>
              <input class="form-control" type="number" [(ngModel)]="document.declaredTotal" [disabled]="autoGenerated || isTranslate"/>
            </div>
          </div>
    
          <div class="row mb-3">
            <div class="col-md-6">
              <button *ngIf="document.id == 0" class="btn btn-outline-primary" (click)="addDocument()" [disabled]="autoGenerated || isTranslate">+ Agregar Documento</button>
              <button *ngIf="document.id != 0" class="btn btn-outline-primary" (click)="addDocument()" [disabled]="autoGenerated || isTranslate">Editar documento</button>
            </div>
            <div class="col-md-6 text-end">
              <button *ngIf="document.id != 0" class="btn btn-outline-danger" (click)="deleteActualDocument()" [disabled]="autoGenerated || isTranslate">Eliminar Actual</button>
            </div>
          </div>
          

        </div>
      </div>
    </div>
  </div>
  <div class="card mb-3" *ngIf="document.id != 0 && autoGenerated == false">
    <div class="card-body">
      <div class="row">
        <div class="d-flex flex-row gap-2 items-center">
          <h3>
            Equipo a registrar
          </h3>
          <span (click)="showDetails= !showDetails">
            <i class="fa fa-eye" style="color: var(--bs-bg-servicios)" *ngIf="!showDetails"></i>
            <i class="fa fa-eye-slash" style="color: var(--bs-bg-servicios)" *ngIf="showDetails"></i>
          </span>
        </div>
        <div class="table-responsive mb-4" style="margin-bottom: 0; overflow-y: inherit; max-height: none; overflow-x: auto;" *ngIf="showDetails">
          <table class="table table-striped" style="margin-top: 4px;">
            <thead>
                <tr class="tr-middle">
                  <th class="limit-td">
                    Descripción
                  </th>
                  <th class="ta">
                    Cantidad
                  </th>
                  <th class="ta">
                    Precio
                  </th>
                  <th class="ta">
                    Subtotal
                  </th>
                  <th>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of tempDetails">
                    <tr class="tr-middle">
                      <td class="ta">
                        {{ item.description }}
                      </td>
                      <td class="ta">
                        {{ item.quantity }}
                      </td>
                      <td class="ta">
                        {{ item.price }}
                      </td>
                      <td class="ta">
                        Q {{ (item.quantity*item.price).toFixed(2) }}
                      </td>
                      <td>
                        <button class="btn btn-outline-primary" (click)="setFormEquipment(item)">Usar</button>
                      </td>
                    </tr>
                  </ng-container>
              </tbody>
          </table>
        </div>

          <!-- Datos del documento -->
    
          <div class="row mb-3">
            <div class="col-md-3">
              <label>Código</label>
              <input class="form-control" [(ngModel)]="newRegister.code" placeholder="Código del equipo"/>
            </div>
            <div class="col-md-3">
              <label>Nombre del producto</label>
              <input class="form-control" [(ngModel)]="newRegister.name" placeholder="Nombre de producto"/>
            </div>
            <div class="col-md-3">
              <label>Costo del producto</label>
              <input class="form-control" type="number" [(ngModel)]="newRegister.cost"/>
            </div>
            <div class="col-md-3">
              <label>Cantidad</label>
              <input class="form-control" type="number" [(ngModel)]="newRegister.quantity"/>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label>Persona asignada</label>
              <input class="form-control" [(ngModel)]="newRegister.asignedName" placeholder="Persona asignada"/>
            </div>
            <div class="col-md-3">
              <label>DPI</label>
              <input class="form-control" type="number" [(ngModel)]="newRegister.asignedDPI"/>
            </div>

            <div class="col-md-3">
              <label>Bodega</label>
              <div class="form-group" style="width: 100%;">
                <div class="input-group">
                  <app-input-autocomplete
                    (changeStatus)="selectWarehouse($event.filterElement, 'newRegister')"
                    (inputMethod)="searchWarehouse('newRegister')"
                    [allBorderRadius]="false"
                    [filterElements]="newRegisterWarehouses"
                    [placeholder]="'Ingresa una bodega'"
                    [custom]="true"
                    [inputs]="newRegisterFilterWarehouse">
                    <ng-template #itemsTemplate let-filter>
                      <div items>
                        <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">{{ filter.name }}</h5>
                        <span class="text-muted" style="color: white !important;">
                          {{ filter.code }} - NIT:
                          <ng-container *ngIf="filter.nit">
                            <b>{{ filter.nit }}</b>
                          </ng-container>
                          <ng-container *ngIf="!filter.nit">
                            <span style="color: gray;">
                              <i class="fa fa-circle-info"></i>No cuenta con NIT
                            </span>
                          </ng-container>
                        </span>
                      </div>
                    </ng-template>
                  </app-input-autocomplete>
                </div>
              </div>
            </div>            
            
            <div class="col-md-3">
              <label>Categoría</label>
              <select class="form-select" [(ngModel)]="newRegisterCategoryId" (change)="onNewRegisterCategoryChange()">
                <option [ngValue]="null">Seleccione categoría</option>
                <option *ngFor="let category of depreciations" [ngValue]="category.id">
                  {{ category.name }}
                </option>
              </select>
            </div>
            
            <div class="col-md-3">
              <label>Tipo de depreciación</label>
              <select class="form-select" [(ngModel)]="newRegisterDepreciationId">
                <option [ngValue]="null">Seleccione tipo</option>
                <option *ngFor="let dep of getDepreciationsForCategory(newRegisterCategoryId)" [ngValue]="dep.id">
                  {{ dep.name }}
                </option>
              </select>
            </div>
            
            <div class="col-md-3">
              <label>Porcentaje</label>
              <input class="form-control" type="text" [value]="newRegisterPercentage * 100 + '%'" disabled />
            </div>
            
          </div>
          <button class="btn btn-outline-primary" (click)="addPpeRegister()">+ Agregar Equipo</button>
      </div>
    </div>
  </div>
  <div class="card mb-3" *ngIf="document.id != 0">
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <h3>Equipos registrados</h3>
        </div>
        <div class="col-auto text-end">
          <h5>Costo total acumulado: Q{{ totalCumulative | number:'1.2-2' }}</h5>
        </div>
        <div class="col" id="list-container">
          <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none; overflow-x: auto;">
            <table class="table table-striped" style="margin-bottom: 150px; margin-top: 10px;">
              <thead>
                <tr class="tr-middle">
                  <th class="limit-td">
                    Código
                  </th>
                  <th class="ta">
                    Nombre
                  </th>
                                  <th class="ta">
                    Cantidad
                  </th>
                  <th class="ta">
                    Costo
                  </th>
                  <th class="ta">
                    Persona Asignada
                  </th>
                                  <th class="ta">
                    DPI
                  </th>
                                  <th class="ta">
                    Bodega
                  </th>
                                  <th class="ta">
                    Categoria
                  </th>
                  <th class="ta">
                    Tipo de depreciación
                  </th>
                                  <th class="ta">
                    Porcentaje de depreciación
                  </th>
                  <th>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let ppeitem of pagination.filter">
                                  <tr class="tr-middle">
                                    <td class="ta">
                                      {{ ppeitem.code }}
                                    </td>
                                    <td class="limit-td-100">
                                      {{ ppeitem.name }}
                                    </td>
                                    <td class="ta">
                                      {{ ppeitem.quantity }}
                                    </td>
                                    <td class="ta">
                                      {{ ppeitem.cost | currency: 'Q' }}
                                    </td>
                                    <td class="ta">
                                      <input style="width: 100%;" class="form-control form-control-sm" type="text" [(ngModel)]="ppeitem.asignedName" />
                                    </td>
                                    <td class="ta" style="min-width: 150px;">
                                      <input style="width: 100%;" class="form-control form-control-sm" type="text" [(ngModel)]="ppeitem.asignedDPI" />
                                    </td>
                                    <td class="ta" style="min-width: 150px;">
                                      <div class="form-group" style="width: 100%;" >
                                          <div class="input-group">
                                              <app-input-autocomplete
                                              (changeStatus)="selectWarehouse($event.filterElement, ppeitem)"
                                              (inputMethod)="searchWarehouse(ppeitem)"
                                              [allBorderRadius]="false"
                                              [filterElements]="ppeitem.warehouses"
                                              [placeholder]="'Ingresa una bodega'"
                                              [custom]="true"
                                              [inputs]="ppeitem.filterWarehouse">
                                              <ng-template #itemsTemplate let-filter>
                                                  <div items>
                                                  <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">{{filter.name}}</h5>
                                                  <span class="text-muted" style="color: white !important;">
                                                      {{filter.code}} - NIT:
                                                      <ng-container *ngIf="filter.nit">
                                                      <b>{{filter.nit}}</b>
                                                      </ng-container>
                                                      <ng-container *ngIf="!filter.nit">
                                                      <span style="color: gray;">
                                                          <i class="fa fa-circle-info"></i>No cuenta con NIT
                                                      </span>
                                                      </ng-container>
                                                  </span>
                                                  </div>
                                              </ng-template>
                                              </app-input-autocomplete>
  
                                          </div>
                                      </div>
                                    </td>
                                    <!-- Categoría -->
                                    <td class="ta" style="min-width: 150px;">
                                          <select style="width: 100%;" class="form-select" [(ngModel)]="ppeitem.selectedCategoryId" (change)="onCategoryChange(ppeitem)">
                                          <option [ngValue]="null">Seleccione categoría</option>
                                          <option *ngFor="let category of depreciations" [ngValue]="category.id">
                                              {{ category.name }}
                                          </option>
                                          </select>
                                      </td>
                                      
                                      <!-- Tipo de depreciación -->
                                      <td class="ta" style="min-width: 150px;">
                                          <select style="width: 100%;" class="form-select"
                                                  [(ngModel)]="ppeitem.depreciation"
                                                  (change)="onDepreciationChange(ppeitem)">
                                            <option [ngValue]="null">Seleccione tipo</option>
                                            <option *ngFor="let depreciation of getDepreciationsForCategory(ppeitem.selectedCategoryId)" [ngValue]="depreciation.id">
                                              {{ depreciation.name }}
                                            </option>
                                          </select>
                                        </td>
                                    <td class="ta">
                                      {{ ppeitem.percentage * 100 }}%
                                    </td>
                                    <td class="td-center">
                                      <div style="display: flex; justify-content: space-evenly;" *ngIf="autoGenerated == false">
                                        <span class="clickeable text-danger" (click)="deletePPEItem(ppeitem)">
                                          <i class="fa fa-trash"></i>
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </ng-container>                              
                <tr *ngIf="pagination.filter.length == 0">
                  <td colspan="10" class="ta" style="color: gray">
                    <i class="fa fa-circle-info"></i>No se encontraron documentos pendientes
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
                  <div style="margin-top: 10px;">
                      <app-loading-button [object]="buttonSave" [logo]="true" [colorLoading]="'white'" (clicked)="saveAllItems()">
                      </app-loading-button>
                  </div>
          <!-- <app-pagination-custom [elements]="pagination"></app-pagination-custom> -->
        </div>
      </div>
    </div>
  </div>
</div>
